// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as accountActions from '../account/actions';
import * as serviceActions from '../service/actions';
import AccountSelectContainer from 'ui/AccountSelectContainer';
// import * as AccountIcons from './Icons';

const styles = theme => ({

});

/*
 * Account selector
 */

class AccountSelect extends Component {
  state = {
  }

  checkSelection = () => {
    var accounts = (this.props.user.userAccountRoles || [])
      .filter(role => ((role.userRoleKey === 'GLOBALADMIN' || role.userRoleKey === 'BILLING_ADMIN' || role.userRoleKey === 'PARTNERS' || role.userRoleKey === 'GRASSHOPPER' || role.userRoleKey === 'GRASSHOPPERSMS' || role.userRoleKey === 'GRASSHOPPERGLOBAL' || this.props.addUserRoles === 'Y') && role.userRoleKey !== 'INACTIVE'));
    if(this.props.showOnlyParentAccounts){
      accounts = accounts.filter(account => account.parentAccountId === undefined);
    }
    // Filter by specific feature if provided (e.g., GRASSHOPPER_AI)
    if(this.props.filterByFeature === 'GRASSHOPPER_AI'){
      accounts = accounts.filter(account => account.showCallHandling === 'Y');
    }
    if (accounts.length > 0 && this.props.accountId === '') {
      this.props.setAccountId(accounts[0].accountId);
      if(this.props.user.userAccountRoles.filter(account => account.accountId === accounts[0].accountId)[0].userRoleKey === 'GLOBALADMIN' || this.props.user.userAccountRoles.filter(account => account.accountId === accounts[0].accountId)[0].userRoleKey === 'BILLING_ADMIN' || this.props.user.userAccountRoles.filter(account => account.accountId === accounts[0].accountId)[0].userRoleKey === 'PARTNERS'
        || this.props.user.userAccountRoles.filter(account => account.accountId === accounts[0].accountId)[0].userRoleKey === 'GRASSHOPPER' || this.props.user.userAccountRoles.filter(account => account.accountId === accounts[0].accountId)[0].userRoleKey === 'GRASSHOPPERSMS' || this.props.user.userAccountRoles.filter(account => account.accountId === accounts[0].accountId)[0].userRoleKey === 'GRASSHOPPERGLOBAL'){
        this.props.queryAccount();
        this.props.getVipCallersByAccount(accounts[0].accountId)
      } else {
        this.props.queryAccountInfo();
      }
      return;
    }

    if (this.props.accountId !== 'n') {
      var selected = accounts.find(account => account.accountId === this.props.accountId);
      if (!selected) {
        this.props.setAccountId('n');
        this.props.setAccount({});
        this.props.setPaymentMethods({});
        this.props.setPlaidLinkToken({});
      }
    }

    if (this.props.accountId === 'n' && this.props.account.accountId) {
      this.props.setAccount({});
    }
  }

  componentDidUpdate() {
    this.checkSelection();
  }
  
  componentDidMount() {
    this.checkSelection();
  }
  
  render() {
    const {  user, queryPaymentMethods,
            accountId, setAccountId, showOnlyParentAccounts,
            queryAccount, queryAccountInfo, addUserRoles, filterByFeature } = this.props;

    var distinctAccounts=[];
    var accounts = (user.userAccountRoles || [])
                    .filter((role,index,arr) => {
                      if((role.userRoleKey === 'GLOBALADMIN' || role.userRoleKey === 'BILLING_ADMIN' || role.userRoleKey === 'PARTNERS' || role.userRoleKey === 'GRASSHOPPER' || role.userRoleKey === 'GRASSHOPPERSMS' || role.userRoleKey === 'GRASSHOPPERGLOBAL' || addUserRoles === 'Y') && role.userRoleKey !== 'INACTIVE' && distinctAccounts.indexOf(role.accountId) === -1){
                        distinctAccounts.push(role.accountId)
                        return true;
                      }else{
                        return false;
                      }
                    });
    if(showOnlyParentAccounts){
      accounts = accounts.filter(account => account.parentAccountId === undefined);
    }
    // Filter by specific feature if provided 
    if(filterByFeature === 'GRASSHOPPER_AI'){
      accounts = accounts.filter(account => account.showCallHandling === 'Y');
    }

    return (
      <AccountSelectContainer>
        <MuiCore.Select
          value={accountId}
          style={{ fontFamily: "Sofia" }}
          onChange={(event) => {
            setAccountId(event.target.value);
            if (typeof this.props.accountChanged === "function") {
              this.props.accountChanged(event.target.value);
            }
            if (event.target.value !== "n") {
              if (
                user.userAccountRoles.filter(
                  (account) => account.accountId === event.target.value
                )[0].userRoleKey === "GLOBALADMIN"
              ) {
                queryAccount();
                queryPaymentMethods(event.target.value);
              } else {
                queryAccountInfo();
              }
            }
          }}
          fullWidth
        >
          {accounts.map((account) => (
            <MuiCore.MenuItem
              key={account.accountId}
              value={account.accountId}
              style={{ fontFamily: "Sofia" }}
            >
              {account.accountNumber} {account.accountName}
            </MuiCore.MenuItem>
          ))}
        </MuiCore.Select>
      </AccountSelectContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    accountId : accountSelectors.getAccountId(state),
    account : accountSelectors.getAccount(state),    
  });
};

const mapDispatchToProps = {
  setAccountId : accountActions.setAccountId,
  setAccount : accountActions.setAccount,
  queryAccount : accountActions.queryAccount,
  queryAccountInfo: accountActions.queryAccountInfo,
  queryPaymentMethods : accountActions.queryPaymentMethods,
  setPaymentMethods : accountActions.setPaymentMethods,
  setPlaidLinkToken : accountActions.setPlaidLinkToken,
  getVipCallersByAccount:serviceActions.getVipCallersByAccount
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AccountSelect))

